
<div class="cardimg" :class="size">
  <div class="icon">
    <iCon class="svg" :iconClass="icon"></iCon>
  </div>
  <div class="data">
    <div class="title">{{name}} 
      <span v-if="star">*</span>
    </div>
    <div class="content">
      <p><span>{{t('__c3d_t4t.__gamma')}}：</span><span >{{gamma}}</span></p>
      <p><span>{{t('__d4e_m8t.__colorTemperature')}}：</span><span>{{color}}</span></p>
      <p><span>{{t('__d4e_m8t.__brightness')}}：</span><span>{{brightness}}</span></p>
    </div>
  </div>
  <div class="check">
    <Checkbox class="button" v-model:isCheck="IsChecked"></Checkbox>
  </div>
</div>

